<script setup>
import {
  getNumClass,
  parseNumberElements,
  normalizeColorList,
  parseStringElements
} from './yongsinUsage.js';

const props = defineProps({
  yData: {
    type: Object,
    required: true
  }
})

// 색상 데이터
const yongsinColorNames = computed(() => parseStringElements(props.yData?.분석상세?.용희활용?.요약정보?.용신?.색상))
const heesinColorNames  = computed(() => parseStringElements(props.yData?.분석상세?.용희활용?.요약정보?.희신?.색상))
const yongsinColors = computed(() => normalizeColorList(yongsinColorNames.value))
const heesinColors  = computed(() => normalizeColorList(heesinColorNames.value))

// 시간 데이터
const yongsinTimes = computed(() => parseStringElements(props.yData?.분석상세?.용희활용?.요약정보?.용신?.시간))
const heesinTimes = computed(() => parseStringElements(props.yData?.분석상세?.용희활용?.요약정보?.희신?.시간))

// 공간데이터
const yongsinDirec = computed(() => props.yData?.분석상세?.용희활용?.요약정보?.용신?.공간)
const heesinDirec = computed(() => props.yData?.분석상세?.용희활용?.요약정보?.희신?.공간)

// 숫자 데이터
const yNums = computed(() => parseNumberElements(props.yData?.분석상세?.용희활용?.요약정보?.용신?.숫자))
const hNums = computed(() => parseNumberElements(props.yData?.분석상세?.용희활용?.요약정보?.희신?.숫자))

/** 시간 배열 → 내부 그리드 설정 */
const makeTimeGrid = (arr) => {
  const items = Array.isArray(arr) ? arr.filter(Boolean) : []
  if (items.length <= 2) {
    return { cols: 1, items }
  }
  const evenItems = items.length % 2 === 0 ? items : [...items, null]
  return { cols: 2, items: evenItems }
}
const yTimeGrid = computed(() => makeTimeGrid(yongsinTimes.value))
const hTimeGrid = computed(() => makeTimeGrid(heesinTimes.value))

</script>
<template>
  <div class="usage-summary-card">
    <!-- 헤더 -->
    <div class="usage-summary__cell head"></div>
    <div class="usage-summary__cell head">색상</div>
    <div class="usage-summary__cell head">시공간</div>
    <div class="usage-summary__cell head">숫자</div>
    <div class="usage-summary__divider"/>
    <!-- 용신 row -->
    <div class="usage-summary__cell rowlabel">용신</div>
    <div class="usage-summary__cell colors">
      <div 
        class="color-list"
        v-for="(c,i) in yongsinColors"
        :key="i">
        <span class="usage-summary__color-chip" :style="{ background:c.hex }"></span>
        <div class="usage-summary__legend">
          <span class="usage-summary__legend-item">{{ c.label }}</span>
        </div>
      </div>
    </div>
    <div class="usage-summary__cell time">
      <div class="usage-time-tit">{{ yongsinDirec }}</div>
      <div class="usage-summary__time-grid" :class="yTimeGrid.cols === 2 ? 'cols-2' : 'cols-1'">
        <div v-for="(t,i) in yTimeGrid.items" :key="'y'+i" class="usage-summary__time-item">
          <span v-if="t">{{ t }}</span>
          <span v-else class="usage-summary__placeholder">&nbsp;</span>
        </div>
      </div>
    </div>
    <div class="usage-summary__cell nums">
      <span
        v-for="(n, i) in yNums"
        :key="'y'+i"
        :class="getNumClass(n, { withBase: true })"
      >{{ n }}</span>
    </div>
    <!-- 희신 row -->
    <div class="usage-summary__cell rowlabel">희신</div>
    <div class="usage-summary__cell colors">
      <div 
        class="color-list"
        v-for="(c,i) in heesinColors"
        :key="i">
        <span class="usage-summary__color-chip" :style="{ background:c.hex }"></span>
        <div class="usage-summary__legend">
          <span class="usage-summary__legend-item">{{ c.label }}</span>
        </div>
      </div>
    </div>
    <div class="usage-summary__cell time">
      <div class="usage-time-tit">{{ heesinDirec }}</div>
      <div class="usage-summary__time-grid" :class="hTimeGrid.cols === 2 ? 'cols-2' : 'cols-1'">
        <div v-for="(t,i) in hTimeGrid.items" :key="'h'+i" class="usage-summary__time-item">
          <span v-if="t">{{ t }}</span>
          <span v-else class="usage-summary__placeholder">&nbsp;</span>
        </div>
      </div>
    </div>
    <div class="usage-summary__cell nums">
      <span
        v-for="(n, i) in hNums"
        :key="'h'+i"
        :class="getNumClass(n, { withBase: true })"
      >{{ n }}</span>
    </div>
  </div>
</template>
<style scoped>

</style>